import React, { useState } from 'react';

import BusinessIcon from '@mui/icons-material/Business';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import {
    Box,
    Card,
    Collapse,
    Grid,
    IconButton,
    Link,
    Typography,
} from '@sunwisesoftware/sunwise-ui';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import MapContainer from 'common/components/MapContainer';
import {
    DEFAULT_LAT,
    DEFAULT_LNG,
    DEFAULT_MAP_PREVIEW_ZOOM,
} from 'common/constants';

import iconGoogleMaps from 'resources/iconGoogleMaps.svg';

const PreviewLocation = ({ position }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    if (!position || !position.position) return null;

    const markers = [
        {
            lat: get(position, 'position.latitude'),
            lng: get(position, 'position.longitude'),
            name: position.description,
            title: position.title,
        },
    ];
    const center = {
        lat: get(position, 'position.latitude', DEFAULT_LAT),
        lng: get(position, 'position.longitude', DEFAULT_LNG),
    };

    return (
        <>
            <Card.Body>
                <Grid container>
                    <Grid>{position?.markerIcon || <BusinessIcon />}</Grid>

                    <Grid>
                        <Typography variant="body2" fontWeight="bold">
                            {position.title || t('No location')}
                        </Typography>
                        <Box display="flex" gap={1} mt={1}>
                            <Typography variant="body2">
                                {`(${center.lat}, ${center.lng}`}
                            </Typography>
                            <Link
                                href={`https://www.google.com/maps/search/?api=1&query=${center.lat},${center.lng}`}
                                rel="noopener noreferrer"
                                target="_blank"
                            >
                                <img
                                    alt=""
                                    className="img-fluid"
                                    src={iconGoogleMaps}
                                    width="20px"
                                />
                            </Link>
                        </Box>
                    </Grid>

                    <Grid>
                        <IconButton onClick={() => setOpen(!open)}>
                            {open ? <ExpandLess /> : <ExpandMore />}
                        </IconButton>
                    </Grid>
                </Grid>
            </Card.Body>

            <Collapse in={open}>
                {open && (
                    <MapContainer
                        center={center}
                        markers={markers}
                        zoom={DEFAULT_MAP_PREVIEW_ZOOM}
                    />
                )}
            </Collapse>
        </>
    );
};

PreviewLocation.propTypes = { position: PropTypes.object };

export default PreviewLocation;
